import { CO2eUnit, CostUnit } from './unit.model';

/**
 * Lifecycle stages according to EN 15978.
 * Unsupported stages are commented out.
 */
export enum Lifecycle {
  /**
   * A1-A3: Product stage (raw material supply, transport, manufacturing)
   */
  A1A3 = 'A1-A3',

  /**
   * A4: Transport to construction site
   */
  A4 = 'A4',

  /**
   * A5: Construction/installation waste
   */
  A5 = 'A5',

  /**
   * B1: Use of installed products (EN 15804; carbonation, refrigerant leakage, etc.)
   */
  B1 = 'B1',

  /**
   * B2: Maintenance
   */
  B2 = 'B2',

  /**
   * B3: Repair
   */
  //   B3 = 'B3',

  /**
   * B4: Replacement
   */
  B4 = 'B4',

  /**
   * B5: Refurbishment
   */
  //   B5 = 'B5',

  /**
   * B6: Operational energy use
   */
  B6 = 'B6',
  /**
   * B7: Operational water use
   */
  B7 = 'B7',

  /**
   * C1: Deconstruction/demolition
   */
  C1 = 'C1',

  /**
   * C2: Transport to waste processing
   */
  C2 = 'C2',

  /**
   * C3-C4: Waste processing and disposal. Computed as one combined module per IVL.
   */
  C3C4 = 'C3-C4',

  /**
   * D: Benefits and loads beyond system boundary (reuse, recovery, recycling)
   */
}

/**
 * Lifecycle for each CO2e unit. Note that B1 has two sub-units (B1.1 carbonation
 * and B1.2 refrigerant) that both belong to {@link Lifecycle.B1}.
 */
export const co2eLifecycleLabels: Record<CO2eUnit, Lifecycle> = {
  'co2e_A1-A3': Lifecycle.A1A3,
  co2e_A4: Lifecycle.A4,
  co2e_A5: Lifecycle.A5,
  'co2e_B1.1': Lifecycle.B1,
  'co2e_B1.2': Lifecycle.B1,
  co2e_B2: Lifecycle.B2,
  co2e_B4: Lifecycle.B4,
  co2e_B6: Lifecycle.B6,
  co2e_B7: Lifecycle.B7,
  co2e_C1: Lifecycle.C1,
  co2e_C2: Lifecycle.C2,
  'co2e_C3-C4': Lifecycle.C3C4,
};

/**
 * Lifecycle for each cost unit. B1 and B7 have no cost dimension.
 */
export const costLifecycleLabels: Record<CostUnit, Lifecycle> = {
  'sek_A1-A3': Lifecycle.A1A3,
  sek_A4: Lifecycle.A4,
  sek_A5: Lifecycle.A5,
  sek_B2: Lifecycle.B2,
  sek_B4: Lifecycle.B4,
  sek_B6: Lifecycle.B6,
};

/**
 * Lifecycle labels for CO2e and cost units. e.g. 'sek_A1-A3' -> 'A1-A3'
 */
export const lifecycleLabels: Record<CO2eUnit | CostUnit, Lifecycle> = {
  ...co2eLifecycleLabels,
  ...costLifecycleLabels,
};

export const lifecycles = Object.values(Lifecycle);

export const lifecyclesSet = new Set(lifecycles);

export const isLifecycle = (value: unknown): value is Lifecycle => {
  return lifecyclesSet.has(value as Lifecycle);
};
